import React from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ImageBW from '../../../components/ImageBoundsWrapper';

const PinkButton = ({ onClick, style }) => {
  return (
    <div onClick={onClick} style={{ position: 'relative', cursor: 'pointer' }}>
      <ImageBW
        source={require(asset`Pink_Button.png`)}
        ibw={require(asset`CloseButton.ibw`)}
        style={{}}
        innerStyle={{
          cursor: 'pointer',
          width: '100%',
        }}
        alt="Close"
      />
      <p style={style}>{getText(TEXT_KEY.BONUS_LINK_MESSAGE_BUTTON)}</p>
    </div>
  );
};

export default PinkButton;

